export default function anchorScroll() {
    let isScrolling = false;
    let cachedOffset = null;
    let cachedWidth = null;
    
    return {
        init() {
            // Use passive listener and once option for better performance
            window.addEventListener("load", () => {
                requestAnimationFrame(() => this.scrollToAnchor());
            }, { passive: true, once: true });
            
            // Handle hash changes for SPA navigation
            window.addEventListener("hashchange", () => {
                if (!isScrolling) {
                    requestAnimationFrame(() => this.scrollToAnchor());
                }
            }, { passive: true });
        },
        
        scrollToAnchor() {
            if (isScrolling) return;
            
            const hash = this.getCleanHash();
            if (!hash) return;
            
            const target = this.findTarget(hash);
            if (!target) return;
            
            const offset = this.getOffset();
            const elementPosition = target.getBoundingClientRect().top + window.scrollY;
            const targetPosition = Math.max(0, elementPosition - offset);
            
            // Avoid unnecessary scrolling if already at target
            if (Math.abs(window.scrollY - targetPosition) < 5) return;
            
            isScrolling = true;
            
            requestAnimationFrame(() => {
                window.scrollTo({
                    top: targetPosition,
                    left: 0,
                    behavior: "smooth"
                });
                
                // Reset flag after scroll completes
                setTimeout(() => {
                    isScrolling = false;
                }, 800);
            });
        },
        
        getCleanHash() {
            try {
                return decodeURIComponent(window.location.hash);
            } catch (e) {
                // Fallback for malformed URIs
                return window.location.hash;
            }
        },
        
        findTarget(hash) {
            try {
                return document.querySelector(hash);
            } catch (e) {
                // Handle invalid selectors - try by ID as fallback
                if (hash.startsWith('#')) {
                    return document.getElementById(hash.slice(1));
                }
                return null;
            }
        },
        
        getOffset() {
            const currentWidth = window.innerWidth;
            
            // Use cached value if width hasn't changed significantly
            if (cachedWidth && Math.abs(cachedWidth - currentWidth) < 50 && cachedOffset !== null) {
                return cachedOffset;
            }
            
            // Update cache
            cachedWidth = currentWidth;
            cachedOffset = currentWidth >= 1600 ? 90 
                         : currentWidth >= 1200 ? 80 
                         : currentWidth >= 960  ? 70 
                         : currentWidth >= 640  ? 60 
                         : 50;
            
            return cachedOffset;
        }
    };
}